import React, { useEffect, useState } from "react";
import { LuLinkedin, LuSparkles } from "react-icons/lu";
import MarketingLayout from "../components/site/MarketingLayout";
import Reveal from "../components/site/Reveal";
import SmoothImage from "../components/site/SmoothImage";
import AerMark from "../components/site/AerMark";
import QrifyMark from "../components/site/QrifyMark";
import PrimaryButton from "../components/site/PrimaryButton";
import BrandTagline from "../components/site/BrandTagline";
import raviPhoto from "../assets/images/ravi1.png";
import samyPhoto from "../assets/images/samy.png";
import arunPhoto from "../assets/images/arun.png";
import visionImg from "../assets/images/vision.png";
import missionImg from "../assets/images/mission.png";

const team = [
  {
    name: "Ravi",
    initials: "DR",
    photo: raviPhoto,
    role: "Dr. Raveendran - Founder & Chairman",
    href: "https://www.linkedin.com/in/raveendran-iyengar-0a01727/",
    bio: "Dr. N. Raveendran is a distinguished professional with over 38 years of diverse experience across advertising, merchant exports and the risk and insurance sectors. For the past 25 years, he has been at the forefront of the insurance industry, leading the development and successful launch of 28 pioneering products. His work has firmly established him as a thought leader in insurance product innovation and strategic risk management. Dr. Raveendran's core strengths include in-depth research, mentorship and executive education. He has made significant contributions to shaping policy frameworks and building capabilities within the insurance ecosystem. Renowned for his strategic thinking and flawless execution, he seamlessly blends industry expertise with academic insight to deliver impactful outcomes. Beyond his professional achievements, Dr. Raveendran is an avid reader, writer and recreational runner—embodying a balanced approach to leadership and lifelong learning.",
  },
  {
    name: "Samy",
    initials: "SD",
    photo: samyPhoto,
    role: "Saumyadeep Datta - Founder, Managing Director & CEO",
    href: "https://www.linkedin.com/in/saumyadeep-datta-01197223/",
    bio: "Saumyadeep Datta is an alumnus of the Sri Aurobindo International Centre of Education and brings over 25 years of rich, cross-industry experience to the table. Through his career, he has worked with several Fortune 500 companies across diverse sectors—from Office Automation and FMCG to Insurance—collaborating with some of the world's most renowned brands. A proven specialist in building businesses from the ground up, Saumyadeep is known for his expertise in business development, product conceptualisation and innovation. He is driven by a strong sense of values, ethics, discipline and dynamism, which are reflected in every professional endeavour. Beyond the boardroom, Saumyadeep has excelled as a sportsperson and is recognised for his relentless drive to push personal and professional boundaries alike.",
  },
  {
    name: "Arun",
    initials: "AA",
    photo: arunPhoto,
    role: "Lt. General Arun Ananthanarayan PVSM, YSM, SM, VSM (Retd) - Independent Director",
    href: "https://www.linkedin.com/company/alegion-health-tech-pvt-ltd/",
    bio: "Lt. General Arun Ananthanarayan is a distinguished strategic planning expert and leadership coach with nearly four decades of experience in the Indian Army, having served in senior leadership roles across strategy, policy and large-scale operations. He has led complex initiatives in future scenario planning, program execution and organisational transformation, along with international assignments, including United Nations missions. His core strengths include strategic thinking, leadership development and change management. A highly decorated officer, he has been awarded the Param Vishisht Seva Medal, Sena Medal and Yudh Seva Medal for his exceptional service. Beyond his professional career, he is an acclaimed motivational and TEDx speaker, having delivered over 1500 sessions and continues to mentor and inspire individuals and organisations.",
  },
];

const About = () => {
  const [activeMind, setActiveMind] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => {
      setActiveMind((prev) => (prev + 1) % team.length);
    }, 4000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <MarketingLayout>
      <section className="ab-hero">
        <div className="ab-hero__glow" aria-hidden="true" />
        <div className="ab-hero__glow ab-hero__glow--2" aria-hidden="true" />
        <div className="sv-container ab-hero__grid">
          <div className="ab-hero__copy">
            <span className="ab-hero__chip">
              <span className="ab-hero__chip-icon" aria-hidden="true">
                <LuSparkles size={14} strokeWidth={2.25} />
              </span>
              Your Well-Being, Our Priority!
            </span>
            <h1 className="ab-hero__title">
              Revolutionising Health with{" "}
              <span className="ab-hero__title-accent">
                Intelligent, Data-Driven
              </span>{" "}
              Care.
            </h1>
            <p className="ab-hero__lead">
              Empowering Health.{" "}
              <span className="ab-hero__lead-accent">Transforming Lives.</span>{" "}
              Innovating Care.
            </p>
            <div className="hm-hero__actions">
              <PrimaryButton to="/contact" variant="ghost-light">
                Contact Us
              </PrimaryButton>
            </div>
            <div className="hm-hero__tagline">
              <BrandTagline className="sv-brand-tagline--hero" withParens />
              <span>(Health is the only Wealth!)</span>
            </div>
          </div>

          <div className="ab-hero__visual">
            <span className="ab-hero__aura" aria-hidden="true" />
            <span className="ab-hero__ring ab-hero__ring--a" aria-hidden="true" />
            <span className="ab-hero__ring ab-hero__ring--b" aria-hidden="true" />
            <figure className="ab-hero__doctor">
              <SmoothImage
                src="/images/about-hero-visual.png"
                alt="Doctor presenting a glowing holographic health globe with orbiting care icons and analytics dashboards"
              />
              <span className="ab-hero__scan" aria-hidden="true" />
            </figure>
          </div>
        </div>
      </section>

      <section className="sv-section ab-intro">
        <div className="sv-container">
          <Reveal>
            <div className="sv-section-head ab-intro__head">
              <h2 className="sv-h2">
                About <span className="sv-accent">Svasth</span>
              </h2>
              <p className="sv-body ab-intro__body">
                Svasth, an Abyss Tech, leads the way in healthcare innovation, offering services
                that redefine health management. From advanced outpatient and
                inpatient care to comprehensive wellness programmes and the unique{" "}
                <AerMark /> system - <QrifyMark />, we ensure that every aspect of
                your health is meticulously covered. Our technology-driven
                solutions collect real-time health data, analysed by our proprietary
                algorithms to assess risks and recommend intervention procedures.
                This approach enables precise diagnosis for over nine critical
                illnesses, providing personalised treatment plans and expert
                doctor recommendations. We also collaborate with insurance
                companies to streamline portfolio management and reduce costs,
                ensuring immediate and effective care. At Svasth, we're not just
                managing health — we're revolutionising it with technology that
                truly matters.
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="sv-section sv-vm-section">
        <div className="sv-container">
          <div className="sv-vm">
            <Reveal className="sv-vm__reveal">
              <article className="sv-vm__col sv-vm__col--vision">
                <figure className="sv-vm__media">
                  <SmoothImage
                    reflect
                    src={visionImg}
                    alt="Healthcare professionals gathered around a globe"
                    loading="lazy"
                  />
                </figure>
                <div className="sv-vm__copy">
                  <p className="sv-vm__label">OUR VISION</p>
                  <h3 className="sv-vm__title">
                    Empowering Health Through Intelligent Management Solutions.
                  </h3>
                  <span className="sv-vm__rule" aria-hidden="true" />
                  <p className="sv-vm__body">
                    Our vision is to build a sustainable healthcare ecosystem where
                    everyone benefits from proactive, data-driven healthcare
                    management, ensuring a healthier, more connected world where
                    every individual's well-being is prioritised.
                  </p>
                </div>
              </article>
            </Reveal>
            <Reveal className="sv-vm__reveal" delayClass="sv-d2">
              <article className="sv-vm__col sv-vm__col--mission">
                <figure className="sv-vm__media">
                  <SmoothImage
                    reflect
                    src={missionImg}
                    alt="Arrow hitting the bullseye on a target"
                    loading="lazy"
                  />
                </figure>
                <div className="sv-vm__copy">
                  <p className="sv-vm__label">OUR MISSION</p>
                  <h3 className="sv-vm__title">
                    Revolutionising Healthcare with Advanced Technology and
                    Intelligent Solutions.
                  </h3>
                  <span className="sv-vm__rule" aria-hidden="true" />
                  <p className="sv-vm__body">
                    We are dedicated to transforming healthcare by leveraging
                    cutting-edge technology and real-time data to provide
                    comprehensive, personalised care. Our mission is to enhance
                    overall health management, offering tailored solutions that
                    promote well-being and ensure optimal outcomes for every
                    individual.
                  </p>
                </div>
              </article>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="sv-section sv-minds">
        <div className="sv-container">
          <Reveal>
            <div className="sv-section-head">
              <h2 className="sv-h2">
                Meet the Minds Behind <span className="sv-accent">Svasth</span>
              </h2>
              <p className="sv-lead">
                Seasoned operators shaping intelligent, rapid-response healthcare.
              </p>
            </div>
          </Reveal>
          <div className="sv-team" role="list">
            {team.map((person, i) => {
              const isActive = activeMind === i;
              return (
                <Reveal
                  key={person.name}
                  className="sv-team__reveal"
                  delayClass={`sv-d${(i % 3) + 1}`}
                >
                  <article
                    role="listitem"
                    className={`sv-person${isActive ? " is-active" : ""}`}
                    onMouseEnter={() => setActiveMind(i)}
                    onFocus={() => setActiveMind(i)}
                    tabIndex={0}
                  >
                    <div className="sv-person__photo">
                      <SmoothImage
                        src={person.photo}
                        alt={`${person.name} — ${person.role}`}
                        loading="lazy"
                      />
                      <span className="sv-person__shine" aria-hidden="true" />
                    </div>
                    <div className="sv-person__body">
                      <h3 className="sv-h3">{person.name}</h3>
                      <p className="sv-person__role">{person.role}</p>
                      <p className="sv-person__bio">{person.bio}</p>
                      <div className="sv-person__actions">
                        <a
                          href={person.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          aria-label={`${person.name} LinkedIn`}
                          className="sv-icon-btn"
                        >
                          <LuLinkedin size={18} />
                        </a>
                      </div>
                    </div>
                  </article>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default About;
